import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { Observable, Subscription } from "rxjs";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { Router } from "@angular/router";
import { EncuestaService } from "./encuesta.service";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import {
  EncuestaEntry,
  EncuestaSeccionEntry,
  EncuestaPreguntasEntry,
  EncuestaOpcionesEntry,
} from "src/app/shared/entrys/encuesta.entry";
import { TipoPregunta } from "src/app/shared/enumeraciones/tipo-pregunta.enum";
import { PagoParafiscalService } from "../pago-parafiscal/pago-parafiscal.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
// tslint:disable-next-line:max-line-length
import { ModalConfirmacionSolicitudComponent } from "src/app/components/core/layouts/modal-confirmacion-solicitud/modal-confirmacion-solicitud.component";
import { CompletaInformacionService } from "../completa-informacion/completa-informacion.service";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormArray,
  AbstractControl,
} from "@angular/forms";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { AuthService } from "src/app/shared/services/auth.service";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
// tslint:disable-next-line:max-line-length
import {
  TipoConfirmacionModalType,
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { TipoValorPregunta } from "src/app/shared/enumeraciones/tipo-valor-pregunta.enum";
import { debounceTime } from "rxjs/operators";
import { PlataformasElectronicasDigitalesFlow } from "src/app/shared/flows/plataformas-electronicas-digitales.flow";
import { IndicesPasosPlataformasDigitales } from "src/app/shared/enumeraciones/indices-pasos-plataformas-digitales.enum";
import { TipoSolicitud } from 'src/app/shared/enumeraciones/tipo-solicitud.enum';
import { EstadosRnt } from "src/app/shared/enumeraciones/estados-rnt.enum";
import { PuedeDesactivar } from "src/app/shared/guard/has_pending_changes.guard";
// import evaluatex from 'evaluatex'
import { ModalGenericoComponent } from '../../../../../../../shared/layouts/modal-generico/modal-generico.component';
import { ModalValidarRenovacionComponent } from "src/app/components/core/layouts/modal-validar-renovacion/modal-validar-renovacion.component";

@Component({
  selector: "app-encuesta",
  templateUrl: "./encuesta.component.html",
  styleUrls: ["./encuesta.component.scss"],
})
export class EncuestaComponent implements OnInit , PuedeDesactivar{
  @Output()
  pasoActual: EventEmitter<number> = new EventEmitter();

  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  rnt: RNTPrestadorEntry;
  subscription: Subscription;
  encuestas: Array<EncuestaEntry>;
  tipo_pregunta_abierta = TipoPregunta.Abierta;
  tipo_solicitud_reactivacion = TipoSolicitud.Reactivacion;
  tipo_solicitud_renovacion = TipoSolicitud.Renovacion;
  estado_suspendido_por_no_renovar= EstadosRnt.SuspendidoPorNoRenovar;
  tipo_pregunta_multiple = TipoPregunta.Multiple;
  tipo_pregunta_unica = TipoPregunta.Unica;
  tipo_pregunta_lista_valor = TipoPregunta.ListaValor;
  tipo_pregunta_formula = TipoPregunta.Formula;
  tipo_valor_pregunta_fecha = TipoValorPregunta.Fecha;
  siguienteSession = -1;
  siguienteModulo = -1;
  encuestaSeccion: EncuestaSeccionEntry;
  formEncuesta: FormGroup;
  finalizaEncuesta: boolean;
  boton_atras = false;
  boton_atras_paso: string;
  boton: string;
  listasValores: Array<{ keyPregunta: string, lista: Array<{ clave: string, valor: string }>, enlace?: { id: number, seleccion: string } }>;
  listaRespuesta: Array<{ keyPregunta: string, lista: Array<{ opcion_id: number, requiere_respuesta_adicional: boolean, orden: number }> }>;
  keyword = "valor";

  // @ViewChild('numeroPrioridad', { static: false })
  // numeroPrioridadElement: ElementRef;

  constructor(
    private dataSharedService: DataSharedService,
    private router: Router,
    private encuestaService: EncuestaService,
    private pagoParafiscalService: PagoParafiscalService,
    private modalService: NgbModal,
    private authService: AuthService,
    private completaInformacionService: CompletaInformacionService,
    private formBuilder: FormBuilder,
    public ayudaService: AyudasService
  ) {
    this.subscription = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
      this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
    });
    this.formEncuesta = formBuilder.group({});
    this.encuestas = [] as Array<EncuestaEntry>;
    this.encuestaSeccion = {
      preguntas: [] as Array<EncuestaPreguntasEntry>,
    } as EncuestaSeccionEntry;
    this.finalizaEncuesta = false;
    this.listasValores = [] as Array<{ keyPregunta: string, lista: Array<{ clave: string, valor: string }> }>;
    this.listaRespuesta = [] as Array<{ keyPregunta: string, lista: Array<{ opcion_id: number, requiere_respuesta_adicional: boolean, orden: number }> }>;
  }
  permitirSalirDeRuta(): boolean | Observable<boolean> | Promise<boolean>{
    if(this.encuestas.length === 0 || this.finalizaEncuesta){
      return true;
    }
    const modalRef = this.modalService.open(ModalValidarRenovacionComponent, { centered: true });
		modalRef.componentInstance.mensaje = `La encuesta no se puede cerrar una vez iniciada.`;
		modalRef.result.then(() => {
      return false;
		});
  } 

  ngOnInit() {
    this.boton = "Siguiente";
    this.boton_atras_paso = "Atrás";

    if (
      this.authService.getRolDetalleUser() === TipoPrestador.Guia &&
      this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Inmuebles &&
      this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.PlataformaDigitales
    ) {
      //this.pasoActual.emit(3);
      this.pasoActual.emit(5);
    } else {
      /*if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia) {
        this.pasoActual.emit(3);
      } else*/ if (
        this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales ||
        this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Establecimiento ||
        this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia){
        this.pasoActual.emit(5);
      }else {
        this.pasoActual.emit(4);
      }
    }

    

    this.obtenerEstructuraEncuesta();
  }

  obtenerEstructuraEncuesta() {
    this.encuestaService.get(this.rnt).subscribe((resultado) => {
      if (resultado.result) {
        this.encuestas = resultado.data as Array<EncuestaEntry>;
        this.siguienteModulo = this.siguienteSession = 0;
        this.encuestaSeccion = this.encuestas[this.siguienteModulo].secciones[
          this.siguienteSession
        ];
        this.construirFormControls(this.encuestaSeccion);
        if (
          this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia ||
          this.datoSolicitudSharedModel.data.excepcion_municipio_pago_fontur
        ) {
          this.boton = "Finalizar";
          this.boton_atras_paso = "Revisar";
        }
        if(this.datoSolicitudSharedModel.tipo_solicitud == TipoSolicitud.Reactivacion){
          this.boton = "Finalizar";
        }
      } else {
        this.finalizaEncuesta = true;
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: { ...this.rnt },
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
          estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
        });
        if (
          (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Establecimiento ||
            this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) &&
          !this.datoSolicitudSharedModel.data.excepcion_municipio_pago_fontur
        ) {
          if (
            this.rnt.aplica_pago_parafiscales &&
            this.rnt.aplica_pago_parafiscales === true
          ) {
            this.router.navigate(["/solicitud/pago-parafiscal"]);
          } else {
            this.router.navigate(["/mis-establecimientos"]);
          }
        } else {
          this.boton = "Finalizar";
          this.boton_atras_paso = "Revisar";
        }
      }
      this.initReactiviacionRenovacion();
    });
  }
  initReactiviacionRenovacion():void{
    if(this.datoSolicitudSharedModel.data.estado_rnt_id ===
      EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Reactivacion){
      this.pasoActual.emit(6);
      this.boton_atras = false;
    }
  }
  goPaso(): void {
    const rnt: RNTPrestadorEntry = {
      ...this.rnt,
      tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
    };
    this.completaInformacionService.update(rnt).subscribe((resultado) => {
      if (resultado.result) {
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: { ...this.rnt },
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
          estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
        });
        if (
          (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Establecimiento ||
            this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) &&
          !this.datoSolicitudSharedModel.data.excepcion_municipio_pago_fontur
        ) {
          if (
            this.rnt.aplica_pago_parafiscales &&
            this.rnt.aplica_pago_parafiscales === true
          ) {
            this.router.navigate(["/solicitud/pago-parafiscal"]);
          } else {
            if(this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Reactivacion ||
               this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion ){
              this.router.navigate(["/mis-establecimientos"]);
            }else{
              this.router.navigate(["/solicitud/fontur"]);
            }
            
          }
        } else {
          const modalRef = this.modalService.open(
            ModalConfirmarRespuestaComponent,
            { centered: true }
          );
          const confirmarRespuesta = {} as ConfirmarRespuestaModel;
          confirmarRespuesta.tipoConfirmacionModalType =
            TipoConfirmacionModalType.Confirmacion;
          confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
          confirmarRespuesta.message =
            "¿Está seguro que desea finalizar la solicitud?";
          modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
          modalRef.result.then((resultadoModal) => {
            this.pagoParafiscalService
              .delete(this.rnt)
              .subscribe((resultadoMigra) => {
                if (resultadoMigra.result) {
                  this.router.navigate(["/mis-establecimientos"]);
                }
              });
          });
        }
      }
    });
  }

  construirFormControls(encuestaSeccionEntry: EncuestaSeccionEntry) {
    this.formEncuesta = this.formBuilder.group({});
    this.listasValores = [];
    this.listaRespuesta = [];
    encuestaSeccionEntry.preguntas.forEach((element) => {
      element.opciones.forEach((opcion) => {
        switch (element.tipo_pregunta_encuesta_id) {
          case TipoPregunta.Abierta:
            switch (element.pregunta_tipo_valor_id) {
              case TipoValorPregunta.Correo:
                this.formEncuesta.addControl(
                  `control-A${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.emailValidator,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              case TipoValorPregunta.Numerico:
                this.formEncuesta.addControl(
                  `control-A${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.numberOnlyValidator,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              case TipoValorPregunta.Decimal:
                this.formEncuesta.addControl(
                  `control-A${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.numberDecimalOnlyValidator,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              case TipoValorPregunta.Texto:
                this.formEncuesta.addControl(
                  `control-A${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.noWhitespace,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              default:
                this.formEncuesta.addControl(
                  `control-A${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
            }
            break;
          case TipoPregunta.Multiple:
            const controlM = new FormControl(opcion.seleccionado);

            // tslint:disable-next-line:max-line-length
            let formArray = this.formEncuesta.controls[
              `array-M${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
            ] as FormArray;
            if (!formArray) {
              if (element.con_prioridad) {
                this.listaRespuesta.push({ keyPregunta: `array-M${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`, lista: [] })
              }
              this.formEncuesta.addControl(
                // tslint:disable-next-line:max-line-length
                `array-M${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                new FormArray(
                  [],
                  [
                    element.es_obligatoria
                      ? ConfirmeValidators.minSelectedCheckboxesConRespuestaAdicional(1)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? ConfirmeValidators.maxSelectedCheckboxesConRespuestaAdicional(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ]
                )
              );
              // tslint:disable-next-line:max-line-length
              formArray = this.formEncuesta.controls[
                `array-M${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
              ] as FormArray;
            }

            if (opcion.requiere_respuesta_adicional) {
              if (opcion.seleccionado) {
                formArray.push(new FormGroup({
                  [`${formArray.length}`]: controlM,
                  [`respuesta_adicional_${element.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`]
                    : new FormControl(opcion.respuesta_2, [Validators.required])
                }));
              } else {
                formArray.push(new FormGroup({
                  [`${formArray.length}`]: controlM,
                  [`respuesta_adicional_${element.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`]
                    : new FormControl(opcion.respuesta_2, null)
                }));
              }
            }

            if (element.con_prioridad) {
              let numeroOrden = this.getNumeroOrden(opcion.opcion_respuesta_id, opcion.respuesta);
              if (numeroOrden) {
                this.listaRespuesta.find(x => x.keyPregunta == `array-M${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`)?.lista.push({ opcion_id: opcion.opcion_respuesta_id, requiere_respuesta_adicional: opcion.requiere_respuesta_adicional, orden: numeroOrden });
              }
            }

            if (opcion.seleccionado) {
              if (opcion.requiere_respuesta_adicional) {
                // formArray.controls[
                //   `array-M${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
                // ].controls[formArray.length - 1].patchValue({
                //   [`respuesta_adicional_${element.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`]: opcion.respuesta_2,
                // });
                formArray.controls[formArray.length - 1].patchValue({
                  [`respuesta_adicional_${element.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`]: opcion.respuesta_2,
                });
              }
            }

            if (!opcion.requiere_respuesta_adicional) {
              formArray.push(controlM);
            }
            // tslint:disable-next-line:max-line-length
            this.formEncuesta.controls[
              `array-M${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
            ] = formArray;
            break;
          case TipoPregunta.Unica:
            // const controlU = new FormControl(opcion.opcion_respuesta_id, [element.es_obligatoria ? Validators.requiredTrue : null]);
            // tslint:disable-next-line:max-line-length
            const formGroupEncuesta = this.formEncuesta.controls[
              `group-U${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
            ] as FormGroup;
            if (!formGroupEncuesta) {
              // tslint:disable-next-line:max-line-length
              this.formEncuesta.addControl(
                `group-U${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                this.formBuilder.group({
                  // tslint:disable-next-line:max-line-length
                  [`respuesta_unica_${element.pregunta_encuesta_id}`]: [
                    opcion.seleccionado ? opcion.opcion_respuesta_id : "",
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                  ],
                })
              );
            }

            if (opcion.requiere_respuesta_adicional) {
              if (opcion.seleccionado) {
                (this.formEncuesta.get(
                  `group-U${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
                ) as FormGroup).addControl(`respuesta_adicional_${element.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`
                  , new FormControl(opcion.respuesta_2, [Validators.required]));
              } else {
                (this.formEncuesta.get(
                  `group-U${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
                ) as FormGroup).addControl(`respuesta_adicional_${element.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`
                  , new FormControl(opcion.respuesta_2, null));
              }
            }
            if (opcion.seleccionado) {
              // if (opcion.requiere_respuesta_adicional) {
              //   this.formEncuesta.addControl(
              //     `control-A${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
              //     new FormControl(opcion.respuesta, [
              //       element.es_obligatoria ? Validators.required : null,
              //     ])
              //   );
              // }
              this.formEncuesta.controls[
                `group-U${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
              ].patchValue({
                [`respuesta_unica_${element.pregunta_encuesta_id}`]: opcion.opcion_respuesta_id,
              });

              if (opcion.requiere_respuesta_adicional) {
                this.formEncuesta.controls[
                  `group-U${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`
                ].patchValue({
                  [`respuesta_adicional_${element.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`]: opcion.respuesta_2,
                });
              }
            }
            // this.formEncuesta.controls[`group-U${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`] = formGroupEncuesta;
            break;
          case TipoPregunta.ListaValor:
            this.formEncuesta.addControl(
              `control-L${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
              new FormControl(opcion.respuesta, element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia)
            );
            this.encuestaService.cargarListaValor(element.pregunta_encuesta_id, element.clase_pregunta_id, this.rnt.detalle_solicitud_id).subscribe((listaVal) => {
              if (element.enlace) {
                const listaEnlace = encuestaSeccionEntry.preguntas.filter(x => x.enlace == element.enlace && x.pregunta_encuesta_id != element.pregunta_encuesta_id);
                if (listaEnlace && listaVal && listaVal.data && listaEnlace.length > 0) {
                  for (const enlaceSeleccion of listaEnlace) {
                    const pos = listaVal.data.findIndex(x => x.valor === enlaceSeleccion.opciones[0].respuesta);
                    listaVal.data.splice(pos, 1);
                  }
                  this.listasValores.push({ keyPregunta: `control-L${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`, lista: listaVal.data, enlace: { id: element.enlace, seleccion: opcion.respuesta } });
                } else {
                  this.listasValores.push({ keyPregunta: `control-L${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`, lista: listaVal.data, enlace: { id: element.enlace, seleccion: opcion.respuesta } });
                }
              } else {
                this.listasValores.push({ keyPregunta: `control-L${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`, lista: listaVal.data });
              }
            });
            break;
          case TipoPregunta.Formula:
            switch (element.pregunta_tipo_valor_id) {
              case TipoValorPregunta.Correo:
                this.formEncuesta.addControl(
                  `control-F${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.emailValidator,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              case TipoValorPregunta.Numerico:
                this.formEncuesta.addControl(
                  `control-F${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.numberOnlyValidator,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              case TipoValorPregunta.Decimal:
                this.formEncuesta.addControl(
                  `control-F${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.numberDecimalOnlyValidator,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              case TipoValorPregunta.Texto:
                this.formEncuesta.addControl(
                  `control-F${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    ConfirmeValidators.noWhitespace,
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
              default:
                this.formEncuesta.addControl(
                  `control-F${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`,
                  new FormControl(opcion.respuesta, [
                    element.es_obligatoria ? Validators.required : ConfirmeValidators.validacionVacia,
                    element.longitud_minima
                      ? Validators.minLength(element.longitud_minima)
                      : ConfirmeValidators.validacionVacia,
                    element.longitud_maxima
                      ? Validators.maxLength(element.longitud_maxima)
                      : ConfirmeValidators.validacionVacia,
                  ])
                );
                break;
            }
            this.aplicarCalculoDinamico(element, `control-F${element.pregunta_encuesta_id}${element.tipo_pregunta_encuesta_id}`, element.formula, false);
            break;
        }
      });
    });
  }

  onRegresarPaso(): void {
    const rnt: RNTPrestadorEntry = {
      ...this.rnt,
      tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
    };
    this.completaInformacionService.update(rnt).subscribe((resultado) => {
      if (resultado.result) {
        this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
          data: { ...this.rnt },
          tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
          tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
          estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
        });
        if (
          this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Establecimiento
        ) {
          if (
            !this.datoSolicitudSharedModel.data.excepcion_municipio_pago_fontur
          ) {
            this.router.navigate(["solicitud/codigo-conducta"]);
          } else {
            this.router.navigate(["solicitud/completa-informacion"]);
          }
        } else {
          if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
            if (
              !this.datoSolicitudSharedModel.data
                .excepcion_municipio_pago_fontur
            ) {
              this.router.navigate(["solicitud/codigo-conducta"]);
            } else {
              this.router.navigate(["solicitud/completa-informacion-inmueble"]);
            }
          } else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales) {
            PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(IndicesPasosPlataformasDigitales.CompletarInformacionPlataformas, this.router);
          } else {
            this.router.navigate(["solicitud/completa-informacion-guia"]);
          }
        }
      }
    });
  }

  onSiguienteSession() {
    this.siguienteSession += 1;
    if (this.siguienteModulo < this.encuestas.length) {
      if (
        this.siguienteSession >=
        this.encuestas[this.siguienteModulo].secciones.length
      ) {
        if (this.siguienteModulo < this.encuestas.length) {
          this.siguienteSession = 0;
          this.siguienteModulo += 1;
          this.boton_atras = true;
          if (this.siguienteModulo < this.encuestas.length) {
            this.encuestaSeccion = this.encuestas[
              this.siguienteModulo
            ].secciones[this.siguienteSession];
            this.construirFormControls(this.encuestaSeccion);
          } else {
            this.finalizaEncuesta = true;
          }
        }
      } else {
        this.boton_atras = true;
        this.encuestaSeccion = this.encuestas[this.siguienteModulo].secciones[
          this.siguienteSession
        ];
        this.construirFormControls(this.encuestaSeccion);
      }
    } else {
      this.finalizaEncuesta = true;
    }
  }

  onRetrocederSession() {
    if (this.boton_atras) {
      this.siguienteSession -= 1;
      this.encuestaService.get(this.rnt).subscribe((resultado) => {
        if (this.siguienteSession < 0) {
          if (this.siguienteModulo < this.encuestas.length) {
            this.siguienteModulo -= 1;
            this.siguienteSession =
              this.encuestas[this.siguienteModulo].secciones.length - 1;
          }
        }
        if (resultado.result) {
          this.encuestas = resultado.data as Array<EncuestaEntry>;
          this.encuestaSeccion = this.encuestas[this.siguienteModulo].secciones[
            this.siguienteSession
          ];
          this.construirFormControls(this.encuestaSeccion);
        }
        if (this.siguienteModulo === 0 && this.siguienteSession === 0) {
          this.boton_atras = false;
        }
      });
    }
  }

  saveRespuesta(
    pregunta: EncuestaPreguntasEntry,
    opcion: EncuestaOpcionesEntry,
    valorLista
  ) {
    let respuestasTemp = null;
    let dato = null;
    let respuesta2Multiple = null;
    let validDato = true;
    switch (pregunta.tipo_pregunta_encuesta_id) {
      case TipoPregunta.Abierta:
        if (respuestasTemp) {
          respuestasTemp = "";
        }
        const formPreguntaA = this.formEncuesta.get(
          `control-A${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
        );
        validDato = formPreguntaA.valid;
        dato = formPreguntaA.value;
        respuestasTemp = `${dato}`;
        break;
      case TipoPregunta.Multiple:
        if (respuestasTemp) {
          respuestasTemp = "";
        }

        if (pregunta.con_prioridad) {
          const orden = this.listaRespuesta.find(x => x.keyPregunta == `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`)?.lista?.sort((a, b) => a.orden - b.orden) ?? null;
          if (orden && orden.length > 0) {
            orden.forEach((op) => {
              if (!dato) {
                dato = "";
                respuesta2Multiple = "";
              }
              dato += `${op.opcion_id},`;
              if (op.requiere_respuesta_adicional) {
                if (!respuesta2Multiple) {
                  respuesta2Multiple = "";
                }
                const positionRespuestaAdicional = pregunta.opciones.findIndex(x => x.opcion_respuesta_id == op.opcion_id);
                const valorRespuestaAdicional = (this.formEncuesta.get(
                  `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                ) as FormArray).controls[positionRespuestaAdicional].value[`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op.opcion_id}`];
                respuesta2Multiple += `${valorRespuestaAdicional},`;
              } else {
                respuesta2Multiple += `,`;
              }
            });
          }
        } else {
          const valor = this.formEncuesta.get(
            `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
          ) as FormArray;
          if (valor && valor.length > 0) {
            valor.controls.forEach((controlM: any, index) => {
              if (!dato) {
                dato = "";
              }
              if (!controlM.controls && controlM.value) {
                if (!respuesta2Multiple) {
                  respuesta2Multiple = "";
                }

                dato += `${pregunta.opciones[index].opcion_respuesta_id},`;
                respuesta2Multiple += `,`;
              } else if (controlM.controls && controlM.value[index]) {
                dato += `${pregunta.opciones[index].opcion_respuesta_id},`;
              }

              if (pregunta.opciones[index].requiere_respuesta_adicional && (this.formEncuesta.get(
                `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
              ) as FormArray).controls[index].value[index]) {
                if (!respuesta2Multiple) {
                  respuesta2Multiple = "";
                }
                const valorRespuestaAdicional = (this.formEncuesta.get(
                  `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                ) as FormArray).controls[index].value[`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${pregunta.opciones[index].opcion_respuesta_id}`];
                respuesta2Multiple += `${valorRespuestaAdicional},`;
              }
            });
          }
        }
        respuestasTemp = dato;
        break;
      case TipoPregunta.Unica:
        if (respuestasTemp) {
          respuestasTemp = "";
        }
        respuestasTemp = `${opcion.opcion_respuesta_id}`;
        break;
      case TipoPregunta.ListaValor:
        const formPreguntaL = this.formEncuesta.get(
          `control-L${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
        );
        dato = valorLista?.valor ?? null;
        formPreguntaL.setValue(dato);
        // formPreguntaL.updateValueAndValidity();
        validDato = formPreguntaL.valid;
        respuestasTemp = `${dato ?? ""}`;
        break;
      case TipoPregunta.Formula:
        const formPreguntaF = this.formEncuesta.get(
          `control-F${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
        );
        validDato = formPreguntaF.valid;
        dato = formPreguntaF.value;
        respuestasTemp = `${dato}`;
        break;
    }

    if (validDato) {
      const respuesta = {
        anio: this.encuestas[this.siguienteModulo].anio,
        modulo_encuesta_id: this.encuestas[this.siguienteModulo]
          .modulo_encuesta_id,
        seccion_encuesta_id: this.encuestas[this.siguienteModulo].secciones[
          this.siguienteSession
        ].seccion_encuesta_id,
        pregunta_encuesta_id: pregunta.pregunta_encuesta_id,
        lista_respuestas: respuestasTemp,
        clase_pregunta_id: pregunta.clase_pregunta_id,
        tipo_pregunta_id: pregunta.tipo_pregunta_encuesta_id,
        respuesta_2: pregunta.tipo_pregunta_encuesta_id == TipoPregunta.Multiple ? respuesta2Multiple : null
      };

      if (opcion && opcion.requiere_respuesta_adicional) {
        if (pregunta.tipo_pregunta_encuesta_id == TipoPregunta.Unica) {
          respuesta.respuesta_2 = this.formEncuesta.get(
            `group-U${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
          ).get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${opcion.opcion_respuesta_id}`).value
          // respuesta.respuesta_2 = opcion.respuesta_2;
        }

      }

      if (pregunta.tiene_condicion && pregunta.tipo_pregunta_encuesta_id == TipoPregunta.Abierta) {
        this.formEncuesta.get(
          `control-A${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
        ).setErrors({ temp: 'guardando' });
      }

      this.encuestaService
        .update({ ...this.rnt, ...respuesta })
        .subscribe((resultado) => {
          if (resultado.result) {
            /*this.encuestas = resultado.data as Array<EncuestaEntry>;
          this.siguienteModulo = this.siguienteSession = 0;
          this.encuestaSeccion = this.encuestas[this.siguienteModulo].secciones[this.siguienteSession];*/
            if (pregunta.tiene_condicion && pregunta.tipo_pregunta_encuesta_id == TipoPregunta.Abierta) {
              this.formEncuesta.get(
                `control-A${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
              ).setErrors(null);
            }

            if (pregunta.tipo_pregunta_encuesta_id == TipoPregunta.Unica) {
              pregunta.opciones.forEach((op1) => {
                let opcionIgualUnica = opcion.opcion_respuesta_id == op1.opcion_respuesta_id;
                let respuestaFormUnica = this.formEncuesta.get(
                  `group-U${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                ).get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`);
                if (opcionIgualUnica) {
                  op1.seleccionado = true;
                  if (op1.requiere_respuesta_adicional) {
                    if (!respuestaFormUnica.validator || !!!respuestaFormUnica.validator({} as AbstractControl).hasOwnProperty('required')) {
                      this.formEncuesta.get(
                        `group-U${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                      ).get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).setValidators([Validators.required]);
                    }

                    this.formEncuesta.get(
                      `group-U${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                    ).get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).updateValueAndValidity();
                  }
                } else if (op1.requiere_respuesta_adicional) {
                  op1.seleccionado = false;
                  this.formEncuesta.get(
                    `group-U${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                  ).patchValue({ [`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`]: null });

                  if (respuestaFormUnica.validator && !!respuestaFormUnica.validator({} as AbstractControl).hasOwnProperty('required')) {
                    this.formEncuesta.get(
                      `group-U${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                    ).get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).clearValidators();
                  }

                  this.formEncuesta.get(
                    `group-U${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                  ).get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).updateValueAndValidity();
                  op1.respuesta_2 = null;
                }
              });
            }

            if (pregunta.valida_bloqueo || pregunta.es_dependiente || pregunta.enlace) {
              this.refrescarEstructuraEncuesta();
            }
          } else {
            if (pregunta.tiene_condicion && (resultado.control.code == -666 || resultado.control.code == -667)) {
              switch (pregunta.tipo_pregunta_encuesta_id) {
                case TipoPregunta.Abierta:
                  this.formEncuesta.get(
                    `control-A${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                  ).setErrors({ alerta: resultado.control.message });
                  break;
                case TipoPregunta.Formula:
                  this.formEncuesta.get(
                    `control-F${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
                  ).setErrors({ alerta: resultado.control.message });
                  break;
              }
            }
          }
        });
    }
  }

  refrescarEstructuraEncuesta() {
    this.encuestaService.get(this.rnt).subscribe((resultado) => {
      this.encuestas = resultado.data as Array<EncuestaEntry>;
      this.encuestaSeccion = this.encuestas[this.siguienteModulo].secciones[
        this.siguienteSession
      ];
      this.construirFormControls(this.encuestaSeccion);
    });
  }

  getListaValor(pregunta: EncuestaPreguntasEntry): Array<{ clave: string, valor: string }> {
    return this.listasValores.find((x) => x.keyPregunta == `control-L${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`)?.lista ?? [];
  }

  aplicarCalculoDinamico(pregunta: EncuestaPreguntasEntry, idFormPreguntaFormula, formula: string, calcularCampo: boolean, aplicarEventoCambio: boolean = true) {
    // formula: "#34.122.320# - #34.122.321#"
    try {
      const formulaPre = this.formEncuesta.get(idFormPreguntaFormula);
      if (formula) {

        let posI = 0, posF = 0, count = 0;
        let mivariable = formula;
        for (let i = 0; i < formula.length; i++) {
          if (formula.charAt(i) == "#") {
            if (count % 2 == 0) {
              posI = i + 1;
              count += 1;
            } else {
              posF = i - 1;
              count += 1;
            }

            if (count % 2 == 0 && count >= 2) {
              let variablecilla = formula.substring(posI, posF + 1);
              mivariable = mivariable.replace(`#${variablecilla}#`, this.getPregunta(variablecilla, pregunta, idFormPreguntaFormula, formula, aplicarEventoCambio));
              count = 0;
            }

          }
        }


        if (calcularCampo) {
          try {
            // @ts-ignore
            ///<reference path="src/typings.d.ts"/>
            const fn = evaluatex(mivariable);
            formulaPre.setValue(fn());
            this.saveRespuesta(pregunta, null, null);
          } catch (error) {
            formulaPre.setValue(null);
            this.saveRespuesta(pregunta, null, null);
          }

        }

      }
    } catch (error) {

    }
  }

  getPregunta(preguntaStr: string, preguntaEnc: EncuestaPreguntasEntry, idFormPreguntaFormula, formula: string, aplicarEventoCambio: boolean): string {
    const preguntaArr = preguntaStr.split(".");
    const moduloP = Number.parseInt(preguntaArr[0]);
    const seccionP = Number.parseInt(preguntaArr[1]);
    const preguntaP = Number.parseInt(preguntaArr[2]);
    if (moduloP == this.encuestas[this.siguienteModulo].modulo_encuesta_id && seccionP == this.encuestas[this.siguienteModulo].secciones[this.siguienteSession].seccion_encuesta_id) {
      const pregunta = this.formEncuesta.get(`control-A${preguntaP}${TipoPregunta.Abierta}`);
      if (aplicarEventoCambio) {
        pregunta.valueChanges.pipe(debounceTime(400)).subscribe((valor) => {
          this.aplicarCalculoDinamico(preguntaEnc, idFormPreguntaFormula, formula, true, false);
        });
      }
      if (pregunta.valid) {
        return pregunta.value;
      } else {
        throw "Formula no valida";
      }
    } else {
      const preguntaFind = this.encuestas.find(x => x.modulo_encuesta_id == moduloP).secciones.find(x => x.seccion_encuesta_id == seccionP).preguntas.find(x => x.pregunta_encuesta_id == preguntaP).opciones[0];
      if (preguntaFind.respuesta) {
        return preguntaFind.respuesta;
      } else {
        throw "Formula no valida";
      }
    }
  }

  //#region Priorización
  getNumeroOrden(opcion_respuesta_id: number, lista_respuesta: string) {
    const pos = lista_respuesta?.split(",").findIndex(x => x == opcion_respuesta_id.toString());
    if (pos >= 0) {
      return pos + 1;
    } else {
      return null;
    }
  }

  getNumeroPrioridad(keyPregunta: string, opcion_respuesta_id: number) {
    const pos = this.listaRespuesta.find(x => x.keyPregunta == keyPregunta)?.lista?.find(x => x.opcion_id == opcion_respuesta_id);
    if (pos) {
      return pos.orden;
    } else {
      return '';
    }
  }

  changeCambioPrioridad(elemento, keyPregunta: string, opcion_respuesta_id: number, requiere_respuesta_adicional: boolean, con_prioridad: boolean) {
    if (con_prioridad) {
      if (!elemento.target.checked) {
        const pos = this.listaRespuesta.find(x => x.keyPregunta == keyPregunta)?.lista?.findIndex(x => x.opcion_id == opcion_respuesta_id);
        this.listaRespuesta.find(x => x.keyPregunta == keyPregunta)?.lista?.splice(pos, 1);
        for (const [index, value] of this.listaRespuesta.find(x => x.keyPregunta == keyPregunta)?.lista.sort((a, b) => a.orden - b.orden).entries()) {
          value.orden = index + 1;
        }
      } else {
        const maxOrden = this.listaRespuesta.find(x => x.keyPregunta == keyPregunta)?.lista?.map(x => x.orden) ?? [0];
        this.listaRespuesta.find(x => x.keyPregunta == keyPregunta)?.lista?.push({ opcion_id: opcion_respuesta_id, requiere_respuesta_adicional: requiere_respuesta_adicional, orden: (maxOrden.length > 0 ? Math.max.apply(Math, maxOrden) : 0) + 1 });
      }
    }
  }

  recalcularRespuestaAdicionalMultiple(pregunta: EncuestaPreguntasEntry,
    opcion: EncuestaOpcionesEntry,
    elemento, keyPregunta: string, opcion_respuesta_id: number, requiere_respuesta_adicional: boolean, con_prioridad: boolean) {
    if (pregunta.tipo_pregunta_encuesta_id == TipoPregunta.Multiple) {
      pregunta.opciones.forEach((op1, i) => {
        let opcionIgualUnica = opcion.opcion_respuesta_id == op1.opcion_respuesta_id;
        let respuestaFormMultiple = (this.formEncuesta.get(
          `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
        ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`);

        if (opcionIgualUnica && opcion.requiere_respuesta_adicional) {
          op1.seleccionado = elemento.target.checked;
          if (elemento.target.checked) {
            if (!respuestaFormMultiple.validator || !!!respuestaFormMultiple.validator({} as AbstractControl).hasOwnProperty('required')) {
              (this.formEncuesta.get(
                `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
              ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).setValidators([Validators.required]);
            }

            (this.formEncuesta.get(
              `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
            ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).updateValueAndValidity();
          } else {
            (this.formEncuesta.get(
              `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
            ) as FormArray).controls[i].patchValue({ [`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`]: null });

            if (respuestaFormMultiple.validator && !!respuestaFormMultiple.validator({} as AbstractControl).hasOwnProperty('required')) {
              (this.formEncuesta.get(
                `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
              ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).clearValidators();
            }

            (this.formEncuesta.get(
              `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
            ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).updateValueAndValidity();
          }

        } else if (op1.requiere_respuesta_adicional && !op1.seleccionado) {
          (this.formEncuesta.get(
            `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
          ) as FormArray).controls[i].patchValue({ [`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`]: null });

          if (respuestaFormMultiple.validator && !!respuestaFormMultiple.validator({} as AbstractControl).hasOwnProperty('required')) {
            (this.formEncuesta.get(
              `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
            ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).clearValidators();
          }

          (this.formEncuesta.get(
            `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
          ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).updateValueAndValidity();
          op1.respuesta_2 = null;
        } else if (op1.requiere_respuesta_adicional && op1.seleccionado) {
          // (this.formEncuesta.get(
          //   `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
          // ) as FormArray).controls[i].patchValue({ [`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`]: null });

          if (respuestaFormMultiple.validator && !!respuestaFormMultiple.validator({} as AbstractControl).hasOwnProperty('required')) {
            (this.formEncuesta.get(
              `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
            ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).setValidators([Validators.required]);
          }
          (this.formEncuesta.get(
            `array-M${pregunta.pregunta_encuesta_id}${pregunta.tipo_pregunta_encuesta_id}`
          ) as FormArray).controls[i].get(`respuesta_adicional_${pregunta.pregunta_encuesta_id}_${op1.opcion_respuesta_id}`).updateValueAndValidity();
        }
      });
    }

    this.changeCambioPrioridad(elemento, keyPregunta, opcion_respuesta_id, requiere_respuesta_adicional, con_prioridad);
  }

  setErrorFormControl(formControlName: string, keyError: string, error: string) {
    this.formEncuesta.get(formControlName).setErrors([{ [keyError]: error }]);
  }

  //#endregion
}
